import api from './Api'


const defalutGetFeedAdminByFeedIdQuery = 'id nickName content createdDate feedHiddenId isHidden feedId category'
export const getFeedAdminByFeedId = <T>(feedId: number, responseQuery: string = defalutGetFeedAdminByFeedIdQuery) => {
    const query = `query getFeedAdminByFeedId($feedId:ID!) { getFeedAdminByFeedId(feedId:$feedId) { ${responseQuery} } }`
    return api.post<IGraphqlResponse<{ getFeedAdminByFeedId: T }>>('/graphql', { query, variables: { feedId } })
}


const defalutGetAllFeedAdminQuery = 'id nickName content createdDate feedHiddenId isHidden feedId'
export const getAllFeedAdmin = <T>(responseQuery: string = defalutGetAllFeedAdminQuery) => {
    const query = `query getAllFeedAdmin { getAllFeedAdmin { ${responseQuery} } }`
    return api.post<IGraphqlResponse<{ getAllFeedAdmin: T }>>('/graphql', { query })
}

export const createFeedMemoAdmin = (createFeedMemoAdminRequest: ICreateFeedMemoAdminRequest) => {
    return api.post<boolean>(`/feed/memo/admin`, createFeedMemoAdminRequest)
}